import { render, staticRenderFns } from "./marketing-secondclassifi.vue?vue&type=template&id=4a988611&scoped=true&"
import script from "./marketing-secondclassifi.vue?vue&type=script&lang=js&"
export * from "./marketing-secondclassifi.vue?vue&type=script&lang=js&"
import style0 from "./marketing-secondclassifi.vue?vue&type=style&index=0&id=4a988611&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a988611",
  null
  
)

export default component.exports